import {
  useQuery
} from "@tanstack/react-query";

import {
  getHomeSections
} from "../../services/catalog";

import type {
  HomeSection,
  HomeSectionKey
} from "../../types/admin";

export function useHomeSections() {
  return useQuery({
    queryKey: [
      "homepage",
      "sections"
    ],

    queryFn:
      getHomeSections,

    staleTime: 0,

    refetchOnMount:
      "always",

    refetchOnWindowFocus:
      true
  });
}

export function findHomeSection(
  sections:
    HomeSection[] | undefined,
  sectionKey:
    HomeSectionKey
): HomeSection | null {
  return (
    sections?.find(
      (section) =>
        section.sectionKey ===
        sectionKey
    ) ?? null
  );
}
